// Copyright 1999-2022. Plesk International GmbH. All rights reserved.

import { makeVar, useReactiveVar } from '@apollo/client';

const pageData = makeVar({});

export const usePageData = () => useReactiveVar(pageData);

export default pageData;
